import React, { useState } from "react";
import { BasePageModal } from "@/shared/components/modal//page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BaseRadioButton } from "@/shared/components/radio-button/base-radio-button";
import { OverlapInfo } from "@/features/accounts/ocr/services/post-trades-model";
import { FAQ_URL } from "@/shared/config/constants";
import { Link } from "react-router-dom";


interface Props {
  onClose: () => void;
  onSelectMethod: (method: string) => void;
  overlapInfo: OverlapInfo;
  isSub?: boolean;
}

export const DuplicateTradesModal = ({ onClose, onSelectMethod, overlapInfo, isSub = false }: Props) => {
  const [method, setMethod] = useState<string>("");

  const tradeCount = method === "1" 
    ? overlapInfo.new_detail_count.toString()
    : overlapInfo.request_detail_count.toString();

  if (!overlapInfo) return null;

  const openFAQPage = () => {
    window.open(FAQ_URL, "_blank");
  };

  return (
    <BasePageModal
      title="重複期間明細取込方法の選択"
      className="md-add-excel-duplicat"
      handleClose={onClose}
      bottomChildren={
        <BaseRoundButton
          buttonText="選択した方法で取り込む"
          onClick={() => {
            onSelectMethod(method);
            onClose();
          }}
          id="select-method"
          loadingNegative={true}
          isActive={method !== ""}
        />
      }
      isSub={isSub}
      disableOverlayClose={true}
    >
      <h2>取引日が重複するデータがあります</h2>
      <h3>
        <span>重複期間：{`${overlapInfo.overlap_range.start} ～ ${overlapInfo.overlap_range.end}`}</span>
        <strong>{tradeCount}</strong>
      </h3>
      <h4>取り込み方法の選択</h4>
      <ol>
        <li>
          <BaseRadioButton
            id ="no-overlap"
            label={<><strong>1. 重複期間の明細を<em>除いて</em>アップロード</strong><span>取込済みの取引明細に変更がない方はこちら</span></>}
            value="重複期間外"
            name="selectMethod"
            checked={method === "1"}
            onChange={() => setMethod("1")}
            isDisabled={false}
          />
        </li>
        <li>
          <BaseRadioButton
          id ="new-trades"
          label={<><strong>2. 重複期間の明細を<em>上書きで</em>アップロード</strong><span>取込済みの取引明細に変更・削除がある方はこちら</span></>}
          value="削除後全て取り込む"
          name="selectMethod"
          checked={method === "2"}
          onChange={() => setMethod("2")}
          isDisabled={false}
        />
        </li>
        <li>
          <BaseRadioButton
          id ="leave-trades"
          label={<><strong>3. 重複期間の明細を<em>追加で</em>アップロード</strong><span>すべての取引明細を取り込みたい方はこちら</span></>}
          value="残して全て取り込む"
          name="selectMethod"
          checked={method === "3"}
          onChange={() => setMethod("3")}
          isDisabled={false}
        />
        </li>
      </ol>

    <div className="message">
      <p>注意</p>
      <p>・他製品と連携している方へ</p>
      <p>取込方法の「2」または「3」を選択すると、その後の連携時に仕訳 (または伝票) が重複する恐れがあります。</p>
      <p>他製品と連携する際、登録済みの仕訳 (または伝票) が重複しないようご注意ください。</p>
      <p>詳しくは、<Link to={FAQ_URL} target="_blank" rel="noopener noreferrer">こちら</Link>をご参照ください。</p>
    </div>
    </BasePageModal>
  );
};
